<template>
  <pt-goods-review class="pt-goods-review__withData" @approvalReject="approvalReject" ref="goodsList" @slotOut="slotOut"></pt-goods-review>
</template>

<script>
import PtGoodsReview from './index'
export default {
  name: 'pt-goods-review__withData',
  components: {
    'pt-goods-review': PtGoodsReview
  },
  methods: {
    slotOut (id) {
      this.$store.dispatch('goodsOffShelves', id).then(res => {
        this.$refs.goodsList.goods_list()
      }).catch(err => {
        this.$message.error(err || '商品下架失败')
      })
    },
    approvalReject (id) {
      this.$store.dispatch('approvalReject', id).then(res => {
        this.$refs.goodsList.goods_list()
      }).catch(err => {
        this.$message.error(err || '驳回审核失败')
      })
    }
  }
}
</script>
